import { PlusIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "@tanstack/react-router";
import { t } from "i18next";
import { SubscriptionOnlyButton } from "../SubscriptionOnlyButton/SubscriptionOnlyButton";
import { ValidationSuscriptionButton } from "@/common/enums/enums";

export const TemplatesEmpty = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div className="flex flex-col items-center justify-center gap-4">
        <p className="text-primary-dark">{t("templates.emptyStateCTA")}</p>
        <SubscriptionOnlyButton
          className="mt-4"
          validations={[ValidationSuscriptionButton.PLAN_FREE_TRIAL]}
          onClick={async () => {
            await navigate({ to: "/template/new" });
          }}
        >
          <PlusIcon className="w-5 h-5" />
          {t("templates.newTemplateButton")}
        </SubscriptionOnlyButton>
      </div>
    </div>
  );
};
